/**
 * ZUNO — Gerador de Recibo PDF
 * Abre uma janela de impressão com HTML estilizado.
 * O browser oferece "Salvar como PDF" nativamente — sem dependências externas.
 */

function formatarData(ts) {
  if (!ts) return "—";
  const d = ts.toDate ? ts.toDate() : new Date(ts);
  return d.toLocaleDateString("pt-BR", { day: "2-digit", month: "long", year: "numeric" }) +
    " às " + d.toLocaleTimeString("pt-BR", { hour: "2-digit", minute: "2-digit" });
}

function metodoLabel(m) {
  if (m === "pix") return "Pix";
  if (m === "maquininha") return "Cartão (maquininha)";
  if (m === "cartao_zuno") return "Cartão";
  return "Dinheiro";
}

export function gerarReciboPDF(corrida) {
  const valor = Number(corrida.valorFinalComTaxa || corrida.valor || 0).toFixed(2);
  const destino = corrida.destino?.nome || corrida.destino?.endereco || corrida.destino || "—";
  const origem  = corrida.origem?.endereco || "—";
  const data    = formatarData(corrida.criadoEm);
  const motNome = corrida.motoristaNome || "—";
  const motVei  = [corrida.motoristaMarca, corrida.motoristaModelo].filter(Boolean).join(" ") || "—";
  const motPlaca = corrida.motoristaPlaca || "—";
  const dist    = corrida.distanciaKm ? `${corrida.distanciaKm} km` : "—";
  const tempo   = corrida.tempoMin ? `${corrida.tempoMin} min` : "—";
  const tipo    = corrida.categoria === "elite" ? "Zuno Elite" : "Zuno Movel";
  const metodo  = metodoLabel(corrida.metodoPagamento);
  const corridaId = corrida.id ? corrida.id.substring(0, 12).toUpperCase() : "—";

  const html = `<!DOCTYPE html>
<html lang="pt-BR">
<head>
<meta charset="UTF-8">
<meta name="viewport" content="width=device-width,initial-scale=1">
<title>Recibo Zuno — ${corridaId}</title>
<style>
  * { margin: 0; padding: 0; box-sizing: border-box; }
  body {
    font-family: 'Segoe UI', Arial, sans-serif;
    background: #fff;
    color: #111;
    padding: 32px;
    max-width: 480px;
    margin: 0 auto;
  }
  .header {
    text-align: center;
    margin-bottom: 28px;
    padding-bottom: 20px;
    border-bottom: 2px solid #f0f0f0;
  }
  .logo {
    width: 48px;
    height: 48px;
    background: linear-gradient(135deg, #7c3aed, #a855f7);
    border-radius: 50%;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    font-size: 22px;
    font-weight: 900;
    margin-bottom: 10px;
  }
  .brand { font-size: 22px; font-weight: 800; color: #111; letter-spacing: -0.5px; }
  .subtitle { font-size: 12px; color: #888; margin-top: 4px; }
  .receipt-id { font-size: 11px; color: #aaa; margin-top: 6px; letter-spacing: 1px; }
  .valor-box {
    text-align: center;
    padding: 20px;
    background: linear-gradient(135deg, #f5f3ff, #ede9fe);
    border-radius: 16px;
    margin-bottom: 24px;
    border: 1px solid #ddd6fe;
  }
  .valor-label { font-size: 12px; color: #7c3aed; font-weight: 700; text-transform: uppercase; letter-spacing: 1px; margin-bottom: 6px; }
  .valor { font-size: 42px; font-weight: 900; color: #7c3aed; letter-spacing: -1px; }
  .metodo { font-size: 13px; color: #8b5cf6; margin-top: 6px; font-weight: 600; }
  section { margin-bottom: 20px; }
  .section-title {
    font-size: 10px;
    color: #aaa;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 1.2px;
    margin-bottom: 10px;
    padding-bottom: 6px;
    border-bottom: 1px solid #f0f0f0;
  }
  .row {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    padding: 7px 0;
    gap: 16px;
  }
  .row:not(:last-child) { border-bottom: 1px solid #f7f7f7; }
  .row-label { font-size: 12px; color: #888; flex-shrink: 0; }
  .row-value { font-size: 13px; font-weight: 600; color: #111; text-align: right; }
  .rota-box {
    background: #fafafa;
    border-radius: 12px;
    padding: 14px;
    border: 1px solid #f0f0f0;
    margin-bottom: 20px;
  }
  .rota-item { display: flex; align-items: flex-start; gap: 12px; }
  .rota-dot {
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background: #22c55e;
    margin-top: 3px;
    flex-shrink: 0;
  }
  .rota-dot.dest { border-radius: 3px; background: #ef4444; }
  .rota-line { width: 1.5px; height: 20px; background: #e5e7eb; margin: 4px 0 4px 4px; }
  .rota-text { font-size: 12px; color: #555; line-height: 1.5; }
  .footer {
    text-align: center;
    padding-top: 20px;
    border-top: 1px solid #f0f0f0;
    margin-top: 28px;
  }
  .footer p { font-size: 11px; color: #bbb; line-height: 1.8; }
  .badge {
    display: inline-block;
    padding: 3px 10px;
    border-radius: 20px;
    font-size: 11px;
    font-weight: 700;
    background: #dcfce7;
    color: #16a34a;
    margin-bottom: 4px;
  }
  @media print {
    body { padding: 16px; }
    @page { margin: 1cm; }
  }
</style>
</head>
<body>

<div class="header">
  <div class="logo">Z</div>
  <div class="brand">Zuno</div>
  <div class="subtitle">Comprovante de corrida</div>
  <div class="receipt-id">Nº ${corridaId}</div>
</div>

<div class="valor-box">
  <div class="valor-label">Total pago</div>
  <div class="valor">R$ ${valor}</div>
  <div class="metodo">${metodo}</div>
</div>

<section>
  <div class="section-title">Detalhes da viagem</div>
  <div class="row"><span class="row-label">Data</span><span class="row-value">${data}</span></div>
  <div class="row"><span class="row-label">Tipo</span><span class="row-value">${tipo}</span></div>
  <div class="row"><span class="row-label">Distância</span><span class="row-value">${dist}</span></div>
  <div class="row"><span class="row-label">Duração estimada</span><span class="row-value">${tempo}</span></div>
</section>

<section>
  <div class="section-title">Rota</div>
  <div class="rota-box">
    <div class="rota-item">
      <div class="rota-dot"></div>
      <div class="rota-text">${origem}</div>
    </div>
    <div style="display:flex;align-items:center;padding-left:4px"><div class="rota-line"></div></div>
    <div class="rota-item">
      <div class="rota-dot dest"></div>
      <div class="rota-text" style="font-weight:600;color:#111">${destino}</div>
    </div>
  </div>
</section>

<section>
  <div class="section-title">Motorista</div>
  <div class="row"><span class="row-label">Nome</span><span class="row-value">${motNome}</span></div>
  <div class="row"><span class="row-label">Veículo</span><span class="row-value">${motVei}</span></div>
  <div class="row"><span class="row-label">Placa</span><span class="row-value">${motPlaca}</span></div>
</section>

<div class="footer">
  <div class="badge">✓ Corrida concluída</div>
  <p>
    Zuno Tecnologia em Mobilidade<br>
    Este documento é seu comprovante de pagamento.<br>
    Em caso de dúvidas, acesse o app Zuno.
  </p>
</div>

<script>window.onload = () => { window.print(); }</script>
</body>
</html>`;

  const janela = window.open("", "_blank", "width=520,height=700");
  if (!janela) {
    alert("Permita pop-ups para gerar o recibo.");
    return;
  }
  janela.document.write(html);
  janela.document.close();
}
